export default [
  {
    path: '/report',
    name: 'list-report',
    component: () => import('@/views/report/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.report',
      resource: 'report',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.report',
          active: true,
        },
      ],
    },
  },
]
